// shiftMasterAction.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { ShiftMaster } from './shiftMasterType';

// Create Shift Master
export const createShiftMaster = createAsyncThunk(
    'shiftMaster/create',
    async (shiftData: Omit<ShiftMaster, 'ShiftID'>, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/shift-master', shiftData);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create shift master');
        }
    }
);

// Get All Shift Masters
export const fetchAllShiftMasters = createAsyncThunk(
    'shiftMaster/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/shift-master');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch shift masters');
        }
    }
);

// Get Shift Master by ID
export const fetchShiftMasterById = createAsyncThunk(
    'shiftMaster/fetchById',
    async (shiftId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/shift-master/${shiftId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch shift master');
        }
    }
);

// Update Shift Master
export const updateShiftMaster = createAsyncThunk(
    'shiftMaster/update',
    async ({ shiftId, data }: { shiftId: any; data: Partial<ShiftMaster> }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/shift-master/${shiftId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update shift master');
        }
    }
);

// Delete Shift Master
export const deleteShiftMaster = createAsyncThunk(
    'shiftMaster/delete',
    async (shiftId: any, { rejectWithValue }) => {
        try {
            await employeeServiceApiInstance.delete(`/shift-master/${shiftId}`);
            return { ShiftID: shiftId };
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete shift master');
        }
    }
);
